import React, { useEffect, useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import { delete_icon, edit_icon, logo, Search_icon } from "../../assets/img";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import DeleteTwoToneIcon from "@mui/icons-material/DeleteTwoTone";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { deletes, get, put } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { toast } from "react-toastify";
import { useGlobalContext } from "../../Services/PaginationGlobal";

const customStyles = {
  control: (base) => ({
    ...base,
    backgroundColor: "#F4F4F4",
    borderRadius: "8px",
    borderColor: "#ccc",
    boxShadow: "none",
    padding: "4px 8px",
  }),
  menu: (base) => ({
    ...base,
    maxHeight: 160,
    overflowY: "auto",
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: 160, // scrolling height
    overflowY: "auto", // enable scroll
  }),
  option: (base, state) => ({
    ...base,
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: state.isFocused ? "#f0eaff" : "#fff",
    color: "#000",
    padding: "10px",
  }),
};

const ViewVideo = () => {
  const navigate = useNavigate();
  const { state, pathname } = useLocation();
  const { paginationData, setpaginationData } = useGlobalContext();
  const path = pathname?.replace("/", "");
  let category = {
    ...state?.category,
    label: state?.category?.name,
    value: state?.category?.id,
  };
  let userType = state?.userType;
  let isView = state?.type === "view";

  const initial_Data = {
    userType: { label: userType, value: userType === "User" ? 1 : 2 },
    category: category,
    groupType: category?.groups?.[0],
    language: "",
  };
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState(false);
  const [data, setData] = useState(
    paginationData?.[path]?.category?.id === category?.id
      ? paginationData?.[path]
      : initial_Data,
  );
  const [optionList, setOptionList] = useState({
    languages: [],
  });

  const [videos, setVideos] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState(false);

  const addToGlobal = (d = {}) => {
    setpaginationData((prev) => ({
      ...prev,
      [path]: { ...prev?.[path], ...d },
    }));
  };

  const handleChange = (name, value) => {
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const filterVideos = (list = [], search) => {
    if (list.length === 0 || !search) return list;
    let filtered = list.filter((item) =>
      item?.title?.toUpperCase().includes(search?.toUpperCase()),
    );
    if (filtered.length === 0) toast.info("No Records Found...");
    return filtered;
  };

  //api functions

  const getLanguages = async () => {
    let res = await get(`${URLS.LANGUAGE_LIST}?type=1`);
    if (res?.status === "success") {
      let d = res?.data?.map((item) => ({
        ...item,
        label: item?.name,
        value: item?.id,
      }));
      setOptionList((prev) => ({
        ...prev,
        languages: d,
      }));
      if (!data?.language) handleChange("language", d?.[0]);
    }
  };

  useEffect(() => {
    sessionStorage.setItem("tutorial_videos_active_tab", "3");
    getLanguages();
  }, []);

  const viewList = async () => {
    let { category, groupType, language } = data;
    if (!category || !groupType || !language) return;
    let res = await get(
      `${URLS.VIDEO_VIEW}?category_id=${category?.id}&group_id=${groupType?.id}&language_id=${language?.id}`,
    );
    if (res?.status === "success") {
      handleChange("category", { ...category, groups: res?.groups });
      setVideos(res?.data);
    }
  };

  useEffect(() => {
    setSelectedVideo(false);
    viewList();
    addToGlobal(data);
  }, [data?.groupType, data?.language]);

  const handleDelete = async (data) => {
    let res = await deletes(URLS.VIDEO_DELETE + data?.id + "/");
    if (res?.status === "success") {
      setVideos((prev) => prev?.filter((item) => item?.id != data?.id));
      toast.success(res?.message);
      setSelected(false);
    }
  };

  const handleStatus = async (d) => {
    if (isView || d?.upload_status === "Uploading") return;
    let res = await put(`${URLS.VIDEO_STATUS}${d.id}/`);
    if (res?.status === "success") {
      toast.success(res?.message);
      setVideos((prev) =>
        prev.map((item) =>
          item?.id === d?.id
            ? { ...item, status: d?.status == 1 ? 0 : 1 }
            : item,
        ),
      );
    }
  };

  return (
    <div>
      <Topbar header={"Tutorial Videos"} back={true} />
      <hr className="mt-1 mb-1" style={{ backgroundColor: "#D1D1D6" }}></hr>
      {/* dropdown  */}
      <div className="row mt-3">
        <div className="col-md-6 mb-3">
          <label className="fw-semibold mb-1">
            User Type <span style={{ color: "red" }}>*</span>
          </label>
          <Select
            options={optionList.userType}
            value={data?.userType}
            isDisabled
            placeholder="Select User Type"
            styles={customStyles}
          />
        </div>
        <div className="col-md-6 mb-3">
          <label className="fw-semibold mb-1">
            Category <span style={{ color: "red" }}>*</span>
          </label>
          <Select
            options={[]}
            isDisabled
            value={data?.category}
            onChange={(e) => {
              handleChange("category", e);
            }}
            placeholder="Select Category"
            styles={customStyles}
          />
        </div>
      </div>
      {/* group name  */}
      <div className="row mt-3">
        <label className="fw-semibold mb-1">
          Group Type <span style={{ color: "red" }}>*</span>
        </label>
        <div className="d-flex ac-jb py-3">
          <div className="d-flex gap-3">
            {(data?.category?.groups ?? [])?.map((ele) => {
              return (
                <div
                  key={ele?.id}
                  style={{
                    background:
                      data?.groupType?.id == ele?.id ? "#AE55F5" : "#78788029",
                    padding: "10px 30px",
                    borderRadius: 7,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    handleChange("groupType", ele);
                  }}
                >
                  <p
                    className="f1  text-center fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 "
                    style={{
                      color:
                        data?.groupType?.id == ele?.id ? "#fff" : "#6B7280",
                    }}
                  >
                    {ele?.name} - {ele?.language_count}/
                    {optionList.languages?.length}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {/* languages  */}
      <div className="d-flex pb-3  ac-js mt-3 gap-2 overflow-auto">
        {optionList.languages?.map((lan) => {
          return (
            <div className="px-3 border-right-gray pointer">
              <div
                onClick={() => {
                  handleChange("language", lan);
                }}
                className={`${data?.language?.id === lan?.id ? "border-bottom-line" : ""}  px-3 py-2`}
              >
                <p
                  className="text-center fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 "
                  style={{
                    color:
                      data?.language?.id === lan?.id ? "#AE55F5" : "#6B7280",
                  }}
                >
                  {lan?.name}
                </p>
              </div>
            </div>
          );
        })}
      </div>
      {/* videos section  */}
      <div className="mt-5 ">
        {/* count & search  */}
        <div className="d-flex ac-jb">
          <div className="row">
            <h2 className=" f-w600 f3 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24 ">
              Tutorial Videos
            </h2>
            <div className="f2  fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 light-gray">
              Total No:{" "}
              <strong>{String(videos?.length ?? 0).padStart(2, 0)}</strong>
            </div>
          </div>
          <div className="d-flex ac-js gap-3">
            <div className="search-input">
              <input
                onChange={(e) => setSearch(e.target.value)}
                type="text"
                placeholder="Search"
                className="border-0 "
              />
              <img src={Search_icon} className="search" />
            </div>
            <button
              className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white push-btn "
              onClick={() =>
                navigate("/add-video", {
                  state: {
                    type: "add",
                    data: data,
                  },
                })
              }
            >
              + Tutorial Videos
            </button>
          </div>
        </div>
        <div className="video-scroll-container mt-3">
          {filterVideos(videos, search).map((item, index) => {
            return (
              <div key={index} className="video-card bg-white p-1 rounded-1">
                <div className="video-container">
                  {selectedVideo?.id === item?.id ? (
                    <iframe
                      src={`${item?.video}?autoplay=false&preload=false`}
                      title="Bunny Stream Video"
                      loading="lazy"
                      allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture"
                      allowFullScreen
                      className="video-img"
                    />
                  ) : (
                    <img
                      src={item?.thumbnail_image}
                      alt="video thumbnail"
                      className="video-img"
                    />
                  )}

                  {selectedVideo?.id !== item?.id && (
                    <div className="video-overlay" />
                  )}

                  {selectedVideo?.id !== item?.id && (
                    <div className="video-content">
                      <div className="video-top-row d-flex ac-jb">
                        <div />

                        {!isView && item?.upload_status !== "Uploading" && (
                          <div className="d-flex ac-js gap-2">
                            <button
                              onClick={() => {
                                navigate("/add-video", {
                                  state: {
                                    type: "edit",
                                    data: { ...data, video_data: item },
                                  },
                                });
                              }}
                              className="video-buttons"
                            >
                              <CreateOutlinedIcon
                                htmlColor="#9a36e6"
                                style={{ height: "20px", width: "20px" }}
                              />
                            </button>

                            {userType !== "User" && (
                              <button
                                onClick={() => {
                                  setSelected({ type: "delete", data: item });
                                }}
                                className="video-buttons"
                              >
                                <DeleteTwoToneIcon
                                  htmlColor="#ff2929"
                                  style={{ height: "20px", width: "20px" }}
                                />
                              </button>
                            )}
                          </div>
                        )}
                      </div>

                      <div className="video-center">
                        {item?.upload_status !== "Uploading" && (
                          <button
                            onClick={() => {
                              setSelectedVideo(item);
                            }}
                            className="play-button"
                          >
                            <PlayArrowIcon htmlColor="#000" />
                          </button>
                        )}
                      </div>

                      <div className="video-bottom-row d-flex ac-jb">
                        <button
                          onClick={() => {
                            handleStatus(item);
                          }}
                          style={{
                            cursor:
                              isView || item?.upload_status === "Uploading"
                                ? "default"
                                : "pointer",
                          }}
                          className="video-buttons video-active-btn py-0"
                        >
                          <p
                            className="f2  fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 px-3 m-0"
                            style={{
                              color: item?.status == 1 ? "#16A34A" : "#DC2626",
                            }}
                          >
                            {item?.upload_status === "Uploading"
                              ? "Uploading"
                              : item?.status == 1
                                ? "Active"
                                : "Deactive"}
                          </p>
                        </button>
                        <div />
                        {/* <div className="time-badge px-3 py-0 border-0 rounded-2">
                        <p className="f2 white fs-sm-8 fs-md-8 fs-lg-10 fs-xl-12 fs-xxl-14 m-0">
                          01:01
                        </p>
                      </div> */}
                      </div>
                    </div>
                  )}
                </div>

                <div className="d-flex gap-3 mt-2">
                  {/* <img src={logo} alt="logo" className="logo-icon" /> */}

                  <div className="row">
                    <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-16 m-0">
                      {item?.title}
                    </p>

                    <div className="d-flex ac-js gap-2 ">
                      {(item?.display_on ?? [])?.map((display) => {
                        return (
                          <div className="tag-badge px-2 py-1 rounded-1">
                            <p className="f1 fs-sm-6 fs-md-8 fs-lg-10 fs-xl-12 fs-xxl-14 m-0">
                              {display}
                            </p>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {selected.type === "delete" && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p>Are you sure, want to Delete?</p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button
                onClick={() => handleDelete(selected?.data)}
                className="add-btn w-40"
              >
                Yes
              </button>
              <button
                onClick={() => setSelected(false)}
                className="back-btn f2 w-40"
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewVideo;
